/**
 * Filter Component
 * Gère l'affichage/masquage du bouton reset et la réinitialisation des filtres
 */

export function initFilter(container = document) {
  const filters = container.querySelectorAll('.filter');

  filters.forEach(filterElement => {
    const resetBtn = filterElement.querySelector('.filter__reset');
    const inputs = filterElement.querySelectorAll('input[type="radio"], input[type="checkbox"]');

    if (!resetBtn || inputs.length === 0) return;

    /**
     * Met à jour la visibilité du bouton reset
     */
    function updateResetButtonVisibility() {
      const hasSelection = Array.from(inputs).some(input => input.checked);

      if (hasSelection) {
        resetBtn.removeAttribute('hidden');
      } else {
        resetBtn.setAttribute('hidden', '');
      }
    }

    /**
     * Réinitialise toutes les sélections
     */
    function resetFilter() {
      inputs.forEach(input => {
        input.checked = false;
      });

      // Déclencher l'événement change pour notifier les listeners
      const changeEvent = new Event('change', { bubbles: true });
      filterElement.dispatchEvent(changeEvent);

      updateResetButtonVisibility();
    }

    // Initialisation : masquer le reset si aucune sélection
    updateResetButtonVisibility();

    // Écouter les changements sur tous les inputs
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        updateResetButtonVisibility();
      });
    });

    // Écouter le clic sur le bouton reset
    resetBtn.addEventListener('click', (event) => {
      event.preventDefault();
      resetFilter();
    });
  });
}

// Auto-initialisation au chargement du DOM
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFilter());
  } else {
    initFilter();
  }
}

// Export pour utilisation dans le bundle principal
if (typeof window !== 'undefined') {
  window.initFilter = initFilter;
}
